import {Fragment} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import PrimaryCard from '../../../../components/mazraeKit/cards/primaryCard';
import useGetAdverisements from '../../../../services/hookService/getAdvertisements/useGetAdverisements';
import {RootState} from '../../../../store/redux';
import {CodeToInputGroupName} from '../../../../utilities/helper/codeToInputGroupName';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

const NewestShops = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );
  const {advertisementList} = useGetAdverisements({
    selected_cities_id: locational.map(item => item.id).join(',') || undefined,
    page_size: 7,
  });

  if (advertisementList?.count === 0) return null;

  return (
    <div className="flex flex-col w-full gap-2">
      <div className="flex items-center justify-between w-full px-3 text-md">
        <h5 className="flex items-center p-0 m-0 text-gray-700 text-md">
          جدیدترین آگهی‌ها
        </h5>
        <button
          className="flex items-center text-sm text-green-500"
          onClick={() => {
            googleAnalyticsInstance.eventGoogleAnalytics({
              category: 'newestProducts',
              action: 'رو مشاهده همه جدیدترین آگهی ها کلیک شد',
            });
            navigate(`/advertisement-list-for-all`, {
              state: {from: location?.state?.from},
            });
          }}
        >
          مشاهده همه
          <SpanIcon className="text-lg icon-nameArrow---Left-2" />
        </button>
      </div>
      <div className="w-full px-3 flex gap-2 h-[170px] items-center overflow-x-auto">
        {advertisementList?.results?.map(
          (item: IInputGroupsAdvertisementResults, index: number) => {
            return (
              <Fragment key={index}>
                <PrimaryCard
                  {...item}
                  cardSize="md"
                  onClick={() =>
                    navigate(
                      `/category-card-detail/${
                        CodeToInputGroupName[item.input_group?.code]
                      }/${item.id}`,
                    )
                  }
                />
              </Fragment>
            );
          },
        )}
      </div>
    </div>
  );
};

export default NewestShops;
